module.exports = __webpack_public_path__ + "static/img/200250.b9ea1a2a.png";